<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title font-weight-normal small">{{ $t("Box Office Summary Report") }}</div>
      <small><em>{{ $t("* As Per show Date") }}</em></small>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
               :style="isCinemaAkhil 
    ? { maxWidth: '260px', minWidth: '180px', width: '260px'} 
    : { maxWidth: '350px', minWidth: '180px', width: '350px'}"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-2" :style="{ marginLeft: isCinemaAkhil ? '50px' : '150px' }">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("from") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("to") }}</label
                >
              </div>
            </div>
          </div>

<div
            class="col-lg-6 col-xl-2 align-self-center mb-2"
            v-if="isCinemaAkhil"
          >
            <div class="dropdown-curve-container">
              <label :class="selectedCategoryName ? 'shift-up' : ''"
                >{{ $tc("Category", 1) }}</label
              >
              <multiselect
                v-model="selectedScheduleCategory"
                track-by="ss_category_id"
                label="ss_category_name"
                @select="onSelectScheduleCategory($event, $event)"
                @remove="onRemoveSelectScheduleCategory($event, $event)"
                :options="scheduleCategoryList"
                :multiple="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getBoxOfficeSummaryReport(false, 'N')"
            >
              {{ $t("FETCH") }}
            </button>
          </div>

          <div
            class="col-lg-12 col-xl-12 align-self-center mt-2 d-flex justify-content-end"
            v-if="getBoxOfficeReport.length"
          >
            <!-- <div class="mx-1">{{ $t("download") }} as:</div> -->
            <!-- @click="generateReport('boxOfficeReceiptReport')" -->
            <a
              target="_blank"
              @click="getBoxOfficeSummaryReport(true, 'N')"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                style="cursor:pointer"
                height="25"
                width="25"
              />
            </a>
            <!-- <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
            <span  @click="getBoxOfficeSummaryReport(false,'Y')" title="Download as Excel" style="cursor:pointer">
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span>
          </div>
        </div>
      </div>

          <div class="table-scroll">
            <table
              class="swc-report-table swc_table_header"
              border="1"
              v-if="getBoxOfficeReport.length > 0"
            >
              <thead class="">
                <tr>
                  <th rowspan="2">Movie</th>
                  <th rowspan="2">Movie Format</th> 
                  <th rowspan="2" v-if="(groupByMovieShowDatetime )">Show Date</th>
                  <th rowspan="2" v-if="(groupByMovieShowDatetime )">Show Time</th>
                  <th colspan="4">Paid (excl Comps)</th>
                  <th>Comps</th>
                  <th colspan="4">Paid (incl Comps)</th>
                  <th colspan="2" v-if="!hideonIraq">Box office</th>
                </tr>
                <tr>
                  <th>BO + KIOSK</th>
                  <th>Online</th>
                  <th>Admits</th>
                  <th>Gross Box Office</th>
                  <th></th>
                  <th>BO + KIOSK</th>
                  <th>Online</th>
                  <th>Admits</th>
                  <th>Gross Box Office</th>
                  <th v-if="!hideonIraq">Tax</th>
                  <th v-if="!hideonIraq">Net</th>
                </tr>
              </thead>
              <template
                v-for="(boxOfficeData,
                boxOfficeDataIndex) in getBoxOfficeReport"
              >
                <tr :key="boxOfficeDataIndex">
                  <td
                    :rowspan="
                      boxOfficeData.show_time_array.length +
                        grandTotalNeededCount()
                    "
                    class="text-left"
                  >
                    {{ boxOfficeData.movie_title }} <span v-if="boxOfficeData.ss_category_name">{{ `(${boxOfficeData.ss_category_name})` }}</span>
                  </td>
                   
                </tr>
                          <template
                  v-for="(showTimes,
                  showTimesIndex) in boxOfficeData.show_time_array"
                >
                  <tr :key="showTimesIndex">
                   <td class="text-right" >
                      {{ boxOfficeData.mf_name }}
                    </td>
                    <td class="text-right" v-if="(groupByMovieShowDatetime )">
                      {{ showTimes.show_date }}
                    </td>
                    <td class="text-right" v-if="(groupByMovieShowDatetime )">
                      {{ showTimes.show_time }}
                    </td>
                    <td class="text-right">
                      {{ (showTimes.boxOffice_excl_compl).toFixed(0) }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.online_excl_compl }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.admits_excl_t_gross_amount_before_offer }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          showTimes.paid_excl_t_gross_amount_before_offer
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.is_complementory_ticket }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.boxOffice_incl_compl }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.online_incl_compl }}
                    </td>
                    <td class="text-right">
                      {{ showTimes.admits_incl_comp }}
                    </td>

                    <td class="text-right test">
                      {{
                        currFormat(
                          showTimes.paid_incl_t_gross_amount_before_offer
                        )
                      }}
                    </td>
                    <td class="text-right" v-if="!hideonIraq">
                      {{
                        currFormat(
                          showTimes.paid_incl_tax_gross_amount_before_offer
                        )
                      }}
                    </td>
                    <td class="text-right" v-if="!hideonIraq">
                      {{
                        currFormat(
                          showTimes.paid_incl_net_gross_amount_before_offer
                        )
                      }}
                    </td>
                  </tr>
                </template>
                <tr
                  :key="boxOfficeDataIndex"
                  class="font-weight-bold"
                  v-if="grandTotalNeeded()"
                >
                  <td colspan="3" class="text-right">Movie Total</td>
                  
                  <td class="text-right">
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { boxOffice_excl_compl }) => {
                          return acc + boxOffice_excl_compl;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { online_incl_compl }) => {
                          return acc + online_incl_compl;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      boxOfficeData.grand_total
                        .admits_excl_t_gross_amount_before_offer
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        boxOfficeData.grand_total
                          .paid_excl_t_gross_amount_before_offer
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{ boxOfficeData.grand_total.is_complementory_ticket }}
                  </td>
                  <td class="text-right">
                    <!-- {{ currFormat(boxOfficeData.grand_total.admits_incl_comp) }} -->
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { boxOffice_incl_compl }) => {
                          return acc + boxOffice_incl_compl;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    <!-- {{
                    currFormat(
                      boxOfficeData.grand_total
                        .online_incl_compl
                    )
                  }} -->
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { online_incl_compl }) => {
                          return acc + online_incl_compl;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      boxOfficeData.show_time_array.reduce(
                        (acc, { admits_incl_comp }) => {
                          return acc + admits_incl_comp;
                        },
                        0
                      ).toFixed(0)
                    }}
                  </td>

                  <td class="text-right">
                    {{
                      boxOfficeData.show_time_array
                        .reduce(
                          (acc, { paid_incl_t_gross_amount_before_offer }) => {
                            return acc + paid_incl_t_gross_amount_before_offer;
                          },
                          0
                        )
                        .toFixed(MIN_FRACTION_DIGITS)
                    }}
                  </td>

                  <td class="text-right">
                    {{
                      currFormat(
                        boxOfficeData.grand_total
                          .paid_incl_tax_gross_amount_before_offer
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      currFormat(
                        boxOfficeData.grand_total
                          .paid_incl_net_gross_amount_before_offer
                      )
                    }}
                  </td>
                </tr>
              </template>
            </table>
          </div>

          <!--  -->
             <div style="font-size:18px;font-weight:bold;margin:20px 0 5px 0;text-align:center; margin-top: 45px;" v-if="getBoxOfficeReport.length > 0">
               Summary
             </div>

      <!-- Separate Grand Total Table -->
      <div class="table-scroll" v-if="getBoxOfficeReport.length > 0">
        <table class="swc-report-table swc_table_header" border="1">
          <thead>
            <tr>
              <th colspan="4">Paid (excl Comps)</th>
              <th>Comps</th>
              <th colspan="4">Paid (incl Comps)</th>
              <th colspan="2" v-if="!hideonIraq">Box office</th>
            </tr>
            <tr>
              <th>BO + KIOSK</th>
              <th>Online</th>
              <th>Admits</th>
              <th>Gross Box Office</th>
              <th></th>
              <th>BO + KIOSK</th>
              <th>Online</th>
              <th>Admits</th>
              <th>Gross Box Office</th>
              <th v-if="!hideonIraq">Tax</th>
              <th v-if="!hideonIraq">Net</th>
            </tr>
          </thead>
          <tbody>
            <tr class="grand-total-row">
              <!-- <td :colspan="groupByMovieShowDatetime ? 3 : 1" class="text-left font-weight-bold">Grand Total</td> -->
            
              <td v-if="hideonIraq" 
                  v-for="(item, index222) in Object.keys(grandTotalBoxOffice).splice(0, Object.keys(grandTotalBoxOffice).length - 2)" 
                  :key="index222" 
                  class="text-right font-weight-bold">
                {{ currFormat(grandTotalBoxOffice[item] || 0) }}
              </td>
              <td v-if="!hideonIraq" 
                  v-for="(item, index222) in Object.keys(grandTotalBoxOffice)" 
                  :key="index222" 
                  class="text-right font-weight-bold">
                {{ ["boxOffice_excl_compl", "online_excl_compl", "admits_excl_t_gross_amount_before_offer"].includes(item) ? 
                    grandTotalBoxOffice[item] : currFormat(grandTotalBoxOffice[item] || 0) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
          <!-- Grand Total Section -->
        </div>
      <table
        v-if="getBoxOfficeReport.length === 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
        <thead>
          <tr class="">
            <th rowspan="2">Movie</th>
            <th rowspan="2">Movie Format</th>
            <th rowspan="2" v-if="(groupByMovieShowDatetime )">Show Date</th>
            <th rowspan="2" v-if="(groupByMovieShowDatetime )">Show Time</th>
            <th colspan="4">Paid (excl Comps)</th>
            <th>Comps</th>
            <th colspan="4">Paid (incl Comps)</th>
            <th colspan="2"  v-if="!hideonIraq">Box office</th>
          </tr>
          <tr class="">
            <th>Box Office</th>
            <th>Online</th>
            <th>Admits</th>
            <th>Gross Box Office</th>
            <th></th>
            <th>Box Office</th>
            <th>Online</th>
            <th>Admits</th>
            <th>Gross Box Office</th>
            <th  v-if="!hideonIraq">Tax</th>
            <th  v-if="!hideonIraq">Net</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="14">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

</template>
<script>
import { BASEURL } from "@/config/index";
import VueHtml2pdf from "vue-html2pdf";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import { mapActions, mapGetters } from "vuex";
import { Role, CLIENT_NAME,CLIENT_NAMES_OBJ } from "@/helper/Role";


export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
         scheduleCategoryList: [],
              selectedScheduleCategoryId: null,
              selectedCategoryName: "",
              selectedScheduleCategory: {},
      BASEURL,

      isRoleID: false,
      submitted: false,
      pdfFileName: "",
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCinemaAddress: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      getBoxOfficeReport: [],
      grandTotalBoxOffice: {
        boxOffice_excl_compl: 0,
        online_excl_compl: 0,
        admits_excl_t_gross_amount_before_offer: 0,
        paid_excl_t_gross_amount_before_offer: 0,
        is_complementory_ticket: 0,
        boxOffice_incl_compl: 0,
        online_incl_compl: 0,
        admits_incl_comp: 0,
        paid_incl_t_gross_amount_before_offer: 0,
        paid_incl_tax_gross_amount_before_offer: 0,
        paid_incl_net_gross_amount_before_offer: 0,
      },
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
      this.getShowScheduleCategories();
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {},
  computed: {
        isCinemaAkhil() {
            return CLIENT_NAMES_OBJ.cinemaakhil == this.CLIENT_SETUP_NAME;
          },
    groupByMovieShowDatetime() {
      if (String(this.CLIENT_SETUP_NAME).toUpperCase() == "IRAQ") return false;
      if (String(this.CLIENT_SETUP_NAME).toUpperCase() == "EMPIRE")
        return false;

      return true;
      // return !String(this.CLIENT_SETUP_NAME).toLowerCase()
      //   .includes(String(CLIENT_NAME.EMPIRE ).toLowerCase())

      // !String(this.CLIENT_SETUP_NAME).toUpperCase() == 'IRAQ'
    },
    hideonIraq() {
      return String(this.CLIENT_SETUP_NAME)
        .toUpperCase()
        .includes(String(CLIENT_NAME.IRAQ).toUpperCase());
    },

    ...mapGetters(["getOrganizationDetails"]),
  },
  methods: {
    getShowScheduleCategories() {
            let payload = {
              tableName: "schedule_show_categories",
              is_active: "Y",
            };
            MasterService.GetActiveList(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status && data.Records.length > 0) {
                  this.scheduleCategoryList = data.Records.reverse();
                } else {
                  // Show Error Message:
                  console.log("data.message :", data.message);
                }
              })
              .catch((error) => {
                // Catch Error:
                console.log("Catch Error on getActiveScreenByCinemaId :", error);
              });
          },
          onSelectScheduleCategory(event, category) {
            console.log("selectCategory=>");
            this.selectedCategoryName = category.ss_category_name;
            this.selectedScheduleCategoryId = category.ss_category_id;
            this.selectedScheduleCategory = category;
            // this.isChanged = true;
          },
          onRemoveSelectScheduleCategory() {
            console.log("selectCategory=>");
            this.selectedScheduleCategoryId = null;
            this.selectedCategoryName = "";
            this.selectedScheduleCategory = null;
          },
    onChangeDate(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    grandTotalNeededCount() {
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME ||
        CLIENT_NAME.IRAQ == this.CLIENT_SETUP_NAME
        ? 1
        : 2;
    },
    grandTotalNeeded() {
      console.log(CLIENT_NAME.EMPIRE, this.CLIENT_SETUP_NAME);
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME ||
        CLIENT_NAME.IRAQ == this.CLIENT_SETUP_NAME
        ? false
        : true;
    },
    generateReport(type) {
      if (type == "boxOfficeReceiptReport") {
        this.$refs.html2Pdf &&
          this.$refs.html2Pdf.generatePdf &&
          this.$refs.html2Pdf.generatePdf();
      }
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const date = new Date();
      this.pdfFileName = "Reports" + date.getTime();
      this.htmlToPdfOptions.filename =
        "Box Office Summary Report" + date.getTime();
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },

    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.dropDown.selectedCinemaAddress = event.cine_address
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getBoxOfficeSummaryReport: function (isPdfValue = false, isExcel = 'N') {
      let loader = this.$loading.show();
      this.submitted = true;
      this.getBoxOfficeReport = [];
      Object.keys(this.grandTotalBoxOffice).map((keeey) => {
        this.grandTotalBoxOffice[keeey] = 0;
      });

      let selectedCinemaId = this.dropDown.selectedCinemaId;

      let message;

      if (!selectedCinemaId) {
        message = "Please select a cinema";
      } else if (!this.fromDate) {
        message = "From Date field cannot be empty";
      } else if (!this.toDate) {
        message = "To Date field cannot be empty";
      } else if (moment(this.fromDate).isAfter(moment(this.toDate))) {
        message = "To date should be greater than from date";
      }

      if (message) {
        this.$toasted.show(message);
        return;
      }

      let payload = {
        cinema_id: selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        cinema_address: this.dropDown.selectedCinemaAddress,
        ss_show_category_id: this.selectedScheduleCategoryId
                    ? this.selectedScheduleCategoryId
                    : null,
        isPdf: isPdfValue,
        isExcel
      };
      ReportsService.GetBoxOfficeSummaryReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            console.log("data from api", data.Records);

            if (!this.groupByMovieShowDatetime) {
              data.Records.forEach((movie) => {
                if (movie.movieSummary && movie.movieSummary.length) {
                  movie._movieSummary = JSON.parse(
                    JSON.stringify(movie.movieSummary)
                  );
                  movie._show_time_array = JSON.parse(
                    JSON.stringify(movie.show_time_array)
                  );
                  movie.show_time_array = JSON.parse(
                    JSON.stringify(movie.movieSummary)
                  );
                }
              });
            }

            this.getBoxOfficeReport = data.Records;
            if (this.getBoxOfficeReport.length) {
              if (isPdfValue && data.pdfpath) {
                window.open(data.pdfpath, "_blank");
              }
              if (data.excelPath && isExcel == "Y") {
                          window.open(data.excelPath, "_blank");
                        }
              this.getBoxOfficeReport.map((boxOfficeData) => {
                boxOfficeData.show_time_array.map((_sss) => {
                  Object.keys(this.grandTotalBoxOffice).map((keeey) => {
                    this.grandTotalBoxOffice[keeey] =
                      this.grandTotalBoxOffice[keeey] + (_sss[keeey] || 0);
                  });
                });
              });
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },
    excelDownload() {
      let new_records = [];
      let temp_arr = this.getBoxOfficeReport;
      temp_arr = this.getBoxOfficeReport.map((x) => {
        x.show_time_array.map((z) => {
          let obj = {
            ...x,
            ...z,
          };
          if (obj.ss_category_name) {
        obj.movie_title = `${obj.movie_title} (${obj.ss_category_name})`;
      }
      console.log("obj=>",obj)
          new_records.push(obj);
        });
      });
      let data = [
        {
          sheet: "BoxOfficeSummary Report",
          columns: [
            {
              value: "movie_title",
              label: "Movie Name",
            },
            {
              value: "mf_name",
              label: "Movie Format",
            },
            {
              value: "show_date",
              label: "Show Date",
            },
            {
              value: "show_time",
              label: "Show Time",
            },
            {
              value: "boxOffice_excl_compl",
              label: "BO + KIOSK(excl)",
            },
            {
              value: "online_excl_compl",
              label: "Online(excl)",
            },
            {
              value: "admits_excl_t_gross_amount_before_offer",
              label: "Admits(excl)",
            },
            {
              value: "paid_excl_t_gross_amount_before_offer",
              label: "Gross Amount(excl)",
            },
            {
              value: "is_complementory_ticket",
              label: "Complementary Ticket",
            },
            {
              value: "boxOffice_incl_compl",
              label: "BO + KIOSK(incl)",
            },
            {
              value: "online_incl_compl",
              label: "Online(incl)",
            },
            {
              value: "admits_incl_comp",
              label: "Admits(incl)",
            },
            {
              value: "paid_incl_t_gross_amount_before_offer",
              label: "Gross Amount(incl)",
            },
            {
              value: "paid_incl_tax_gross_amount_before_offer",
              label: "Tax",
            },
            {
              value: "paid_incl_net_gross_amount_before_offer",
              label: "Net Amount",
            },

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ].filter((header) => {
            return this.groupByMovieShowDatetimes
              ? true
              : !header.value.startsWith("show_");
          }),
          content: new_records,
        },
      ];
      let from_daten = moment(this.fromDate).format("YYYY-MM-DD");
      let to_daten = moment(this.toDate).format("YYYY-MM-DD");
      let cinema_name = this.dropDown.selectedCinemaName || "";
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let settings = {
        // fileName: `BoxOfficeSummaryReport${new Date().getTime()}`,
        fileName: `BoxOfficeSummaryReport-${cinema_name}_${from_daten}_${to_daten}_on${dateTime}`,
      };
      xlsx(data, settings);
    },
  },
};
</script>

<style>


.swc-report-table {
  table-layout: auto !important;
  /* border: 1px solid black; */
    font-size: 12px;
}
/* .swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
} */
thead tr th{
  font-size: 12px;
  /* padding: 4px 6px;   
  line-height: 1.2; */
}

.multiselect__single,
.multiselect__tags span {
  display: block;
  max-width: 100%;       /* respects the width you gave via :style */
  white-space: nowrap;   
  overflow: hidden;      
  text-overflow: ellipsis; 
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/BoxOfficeSummary.vue